import { ToolTip } from 'components/controls';
import NameCellWithImage from 'components/controls/image-cell';
import { useWorkspace } from 'hooks/useWorkspace';
import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export type CompaniesColumns = {
    id: string;
    name: string;
    companyOwnerId: string;
    createdAt: string;
};

export const useCompanyTableColumns = (): MRT_ColumnDef<CompaniesColumns>[] => {
    const { t } = useTranslation();
    const { baseWorkspaceUrl } = useWorkspace();

    return useMemo(
        () => [
            {
                accessorKey: 'name',
                header: t('TABLE_HEADERS.NAME'),
                size: 400,

                Cell: ({ cell }) => {
                    const path = `${baseWorkspaceUrl}/company/${cell.row.original.id}`;

                    return (
                        <ToolTip
                            disableHoverListener={cell.row.original['name'].length < 50}
                            title={cell.getValue<string>()}
                            placement="top-end"
                        >
                            <NameCellWithImage cell={cell} isLink path={path} target="_self" />
                        </ToolTip>
                    );
                },
                enableColumnActions: false,
            },
            {
                id: 'companyOwnerId',
                accessorKey: 'companyOwnerName',
                header: t('TABLE_HEADERS.COMPANY_OWNER'),
                filterVariant: 'autocomplete',
                size: 150,
                enableSorting: false,
                enableColumnActions: false,
            },
            {
                accessorKey: 'createdAt',
                header: t('TABLE_HEADERS.CREATION_DATE'),
                size: 100,
                enableColumnActions: false,
                enableColumnFilter: false,
            },
        ],
        [t, baseWorkspaceUrl],
    );
};
